import { decodeUrl } from 'utils/decode'
import { apiConfig as apiPatient } from 'services/api'

type OrderProps = {
	value: string
	currency_code: 'MXN'
}

export type Intent = 'CAPTURE' | 'AUTHORIZE'

export enum TrustLevel {
	TRUST = '1',
	UNKNOWN = '0',
	UNTRUST = '2',
}

export type Payer = {
	id: string
	firstName: string
	lastName: string
	email: string
	country: string
	createdAt?: Date
	trustLevel?: TrustLevel
	highRisk?: boolean
}

export type PaymentOrderStatus = 'CREATED' | 'COMPLETED' | 'ERROR' | 'CANCELED'

export type CardDetail = {
	last_digits: string
	brand: string
	type: string
}

export type PaymentSource = {
	type: 'CARD' | 'UNKNOWN'
	data: CardDetail | any
}

export type PaymentOrderResponse = {
	provider: string
	orderId: string
	order: any
	status: PaymentOrderStatus
	statusDescription: string
	payer?: Payer
	purchaseUnit?: any[]
	paymentSource?: PaymentSource
	clientMetadataId?: string
}

export const api = (credentials: { apiKey: string; token: string }) => {
	const { deviceToken } = decodeUrl(window.location.search)
	const http = apiPatient({
		baseURL: process.env.REACT_APP_BASE_API,
		headers: {
			'Content-Type': 'application/json',
			'x-api-key': credentials.apiKey,
			'x-auth-token': deviceToken,

			Authorization: `Bearer ${credentials.token}`,
		},
	})

	const getClientToken = async (): Promise<string> => {
		try {
			const response = await http.get('/payments/client-credentials')
			return response?.data?.token || ''
		} catch (e: any) {
			console.error(e)
			throw new Error('Error al conectar con el procesador de pagos')
		}
	}

	const createOrder = async (
		order: OrderProps,
	): Promise<PaymentOrderResponse | false> => {
		try {
			const response = await http.post('/payments/orders', {
				...order,
			})
			return response?.data || false
		} catch (e) {
			console.error(e)
			throw new Error('Error al crear la orden de pago')
		}
	}

	const captureOrder = async (
		orderId: string,
	): Promise<PaymentOrderResponse | false> => {
		try {
			const response = await http.post(`/payments/orders/${orderId}/capture`)
			return response?.data || false
		} catch (e) {
			console.error(e)
			throw new Error('Error al confirmar el pago')
		}
	}

	return {
		http,
		getClientToken,
		createOrder,
		captureOrder,
	}
}
